import React, { useCallback, useEffect, useState } from "react";
import { Row, Col } from "antd";

import UserForm from "../../components/user/userForm";
import { getEntities } from "../../modules/crudOperations";
import Table from "../../components/oneTimeLoginList/table";
import Header from "../../components/oneTimeLoginList/header";

export default function OneTimeLoginList() {
  const [userFormRef, setUserFormRef] = useState();

  const [showNewUser, setShowNewUser] = useState();
  const handleNewClick = useCallback(() => {
    userFormRef && userFormRef.resetFields();
    setShowNewUser(true);
  }, [userFormRef]);

  const [oneTimeLogins, setOneTimeLogins] = useState();
  const loadUsers = useCallback(() => {
    getEntities("user/one-time-login", setOneTimeLogins, (u) => ({
      key: u.oneTimeLoginId,
      firstname: u.firstname,
      lastname: u.lastname,
      username: u.username,
      email: u.email,
      blocked: u.blocked,
      userRole: u.userRole,
      lastLogin: u.lastLogin,
      passwordValidity: u.passwordValidity,
      inserter: u.inserter,
      changer: u.changer,
      deleter: u.deleter,
      invalid: u.invalid,
      oneTimeLoginId: u.oneTimeLoginId,
      code: u.code,
    }));
  }, []);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  return (
    <Row>
      <Col>
        <Header onNewLoginClick={handleNewClick} />
        <Table oneTimeLogins={oneTimeLogins} onLoadUsers={loadUsers} />
        <UserForm
          oneTimeLogin
          ref={setUserFormRef}
          visible={showNewUser}
          loadUsers={loadUsers}
          setVisible={setShowNewUser}
        />
      </Col>
    </Row>
  );
}
